import searchNumbers from '../../../utils/searchNumbers';

const MIN_SEARCH_DIGITS = 4;

export const filterOptions = (options, search) => {
  return search === '%'
    ? options
    : search.includes('%')
    ? options.filter(num => {
        return searchNumbers(num.number, search);
      })
    : options.filter(num => num.number.includes(search));
};

export const buildSearchFilter = term => {
  const stripped = term.replace(/[^0-9%]/g, '');
  const digits = stripped.replace(/%/g, '');

  if (digits.length < MIN_SEARCH_DIGITS) return void 0;

  return stripped;
};
